import axios from 'axios';
import {
  CHANGE_LANGUAGE_FAIL,
  CHANGE_LANGUAGE_LOADING,
  CHANGE_LANGUAGE_SUCCESS,
  EDIT_USER_FAIL,
  EDIT_USER_LOADING,
  EDIT_USER_SUCCESS,
  ME_SUCCESS,
  PIN_FORM_FAIL,
  PIN_FORM_LOADING,
  PIN_FORM_SUCCESS,
} from '../types';

export const editUser = (userData) => async (dispatch) => {
  dispatch({
    type: EDIT_USER_LOADING,
  });
  try {
    const response = await axios.patch(`/api/users/me`, userData);
    const {
      data: { me },
    } = response;
    dispatch({
      type: ME_SUCCESS,
      payload: { me },
    });
    dispatch({
      type: EDIT_USER_SUCCESS,
    });
  } catch (err) {
    let errorMessage;
    if (err.response?.data?.error) {
      errorMessage = err.response.data.error;
    } else {
      errorMessage = 'Something went wrong on our end.';
    }
    dispatch({
      type: EDIT_USER_FAIL,
      payload: { error: errorMessage },
    });
    throw new Error(errorMessage);
  }
};

export const updatePushToken = (token) => async () => {
  try {
    await axios.patch(`/api/users/me/deviceTokens`, {
      token,
    });
  } catch (err) {
    console.log(err);
  }
};

export const changeLanguage = (language) => async (dispatch) => {
  dispatch({
    type: CHANGE_LANGUAGE_LOADING,
  });
  try {
    const response = await axios.patch('/api/users/language', language);
    dispatch({
      type: CHANGE_LANGUAGE_SUCCESS,
      payload: response.data.language,
    });
  } catch (err) {
    dispatch({
      type: CHANGE_LANGUAGE_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};

export const pinForm = (id) => async (dispatch) => {
  dispatch({ type: PIN_FORM_LOADING });

  try {
    const response = await axios.post(`/api/users/pinForm`, { formId: id });
    dispatch({
      type: PIN_FORM_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: PIN_FORM_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};

export const unpinForm = (id) => async (dispatch) => {
  dispatch({ type: PIN_FORM_LOADING });
  try {
    const response = await axios.patch(`/api/users/unpinForm`, { formId: id });
    dispatch({
      type: PIN_FORM_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: PIN_FORM_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};
